import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { fromURLSearchParams } from 'components/search'

const DEFAULT_RADIUS = 'any'

const initialFilters = {
  radius: 'any',
  division: '',
  access: '',
  programStatus: '',
}

const initialSearchState = history => {
  const urlParams = new URLSearchParams(history.location.search)
  const selection = fromURLSearchParams(urlParams, { initialFilters })
  const access = urlParams.get('access') || ''
  const division = urlParams.get('division') || ''
  const programStatus = urlParams.get('programStatus') || 'open'
  const radius = urlParams.get('radius') || DEFAULT_RADIUS

  const initialState = {
    access,
    division,
    programStatus,
    radius,
    selection,
  }

  return initialState
}

export default function useSearchState() {
  const history = useHistory()
  const [searchState, setSearchState] = useState(initialSearchState(history))
  const { access, division, programStatus, radius, selection } = searchState

  useEffect(() => {
    const params = {
      radius,
      ...selection.toURLSearchParams(),
      ...(access && { access }),
      ...(division && { division }),
      ...(programStatus && { programStatus }),
    }

    const queryString = new URLSearchParams(params).toString()

    history.replace(`${history.location.pathname}?${queryString}`)
  }, [access, division, programStatus, history, radius, selection])

  return [
    searchState,
    changes => setSearchState({ ...searchState, ...changes }),
  ]
}
